import { ShieldCheck, Satellite, Layers } from "lucide-react";
import { BLOG_DATA } from "./data/blogs.js";

// Inline brand SVG icons — no library needed
const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor" aria-hidden="true">
    <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047v-2.66c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.971h-1.513c-1.49 0-1.956.93-1.956 1.884v2.266h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/>
  </svg>
);
const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor" aria-hidden="true">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);
const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor" aria-hidden="true">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);
const YouTubeIcon = () => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor" aria-hidden="true">
    <path d="M23.495 6.205a3.007 3.007 0 0 0-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 0 0 .527 6.205a31.247 31.247 0 0 0-.522 5.805 31.247 31.247 0 0 0 .522 5.783 3.007 3.007 0 0 0 2.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 0 0 2.088-2.088 31.247 31.247 0 0 0 .5-5.783 31.247 31.247 0 0 0-.5-5.805zM9.609 15.601V8.408l6.264 3.602z"/>
  </svg>
);

// src/data.js (excerpt)
export const navigations = [
  {
    label: "About",
    path: "/about",
    submenu: [
      { label: "About Us", path: "/about" },
      { label: "Foundation", path: "/blog/foundation" },
      { label: "Blog", path: "/blog" },
    ],
  },
  {
    tKey: "nav.joinUs",
    label: "Jobs",
    to: "about",
    submenu: [
      { tKey: "nav.careers", label: "Apply", path: "/careers" },
      { tKey: "nav.careersPage", label: "Careers", path: "/security-careers" }
    ],
  },
  {
    tKey: "nav.services",
    label: "Services",
    to: "services",
    submenu: [
      { tKey: "nav.securityGuards",    label: "Security Guards",    path: "/services/security-guards" },
      { tKey: "nav.securitySystems",   label: "Security Systems",   path: "/services/security-systems" },
      { tKey: "nav.staffingSolutions", label: "Staffing Solutions", path: "/services/security-staffing" },
      { tKey: "nav.hybridSolutions",   label: "Hybrid Solutions",   path: "/services/hybrid-security-solutions" },
      { tKey: "nav.transportation",    label: "Transportation",     path: "/services/transportation-security" },
      { tKey: "services.interventionServices", label: "Intervention Services", path: "/services/crisis-intervention-security" },
    ],
  },
  {
    tKey: "nav.securitySolutions",
    label: "Categories",
    to: "services", // top-level still scrolls to Services section on home
    submenu: [
      { tKey: "services.eventSecurity",        label: "EVENT SECURITY",        path: "/services/event-security" },
      { tKey: "services.residentialSecurity",  label: "RESIDENTIAL SECURITY",  path: "/services/residential-security" },
      { tKey: "services.trafficControl",       label: "TRAFFIC CONTROL",       path: "/services/traffic-control" },
      { tKey: "services.fireSurveillance",     label: "FIRE SURVEILLANCE",     path: "/services/fire-watch-security" },
      { tKey: "services.hospitalityServices",  label: "HOSPITALITY SERVICES",  path: "/services/hospitality-security" },
      { tKey: "services.luxurySecurity",       label: "VIP SECURITY", path: "/services/luxury-security" },
      { tKey: "services.lossPrevention",       label: "LOSS PREVENTION",       path: "/services/loss-prevention" },
      { tKey: "services.constructionSecurity", label: "CONSTRUCTION SITE SECURITY", path: "/services/construction-site-security" },
      { tKey: "services.patrolServices",       label: "PATROL SERVICES",       path: "/services/patrol-services" },
      { tKey: "services.commercialProperties", label: "COMMERCIAL PROPERTIES", path: "/services/commercial-properties" },
      { tKey: "nav.educationalSector",          label: "EDUCATIONAL SECTOR",    path: "/services/education-security" },
      { tKey: "services.governmentServices",   label: "GOVERNMENT SERVICES",   path: "/services/government-services" }
    ],
  },

  {
    label: "Locations",
    submenu: [
      { label: "Montréal",        path: "/montreal" },
      { label: "Québec City",    path: "/quebec-city" },
      { label: "Trois-Rivières", path: "/trois-rivieres" },
      { label: "Toronto",        path: "/toronto" },
      { label: "Ottawa",         path: "/ottawa" },
      { label: "Niagara Falls",  path: "/niagara-falls" },
    ],
  },
  {
    tKey: "nav.getAQuote",
    label: "Get a Quote",
    to: "team",
    submenu: [
      { tKey: "nav.requestQuote",     label: "Request a Quote",     path: "/contact#quote-request" },
      { tKey: "nav.consultationCall", label: "Consultation Call",   action: "openPhoneModal" }
    ],
  },
];




export const whyChooseUs = [
  {
    title: "Elite Hiring Standards",
    description:
      "Less than 15% of applicants earn a place on our team. Every officer undergoes background checks, in-house combat and de-escalation training, and ongoing performance evaluations.",

    tTitle: "wcu.cards.professionalStaff.title",
    tDesc: "wcu.cards.professionalStaff.desc",

    icon: <ShieldCheck size={24} />,
  },
  {
    title: "Real-Time Technology",
    description:
      "Live GPS tracking, digital incident reports with photos, and centralized dispatch give you full visibility into your security operation at all times.",

    tTitle: "wcu.cards.safetyFirst.title",
    tDesc: "wcu.cards.safetyFirst.desc",

    icon: <Satellite size={24} />,
  },
  {
    title: "End-to-End Security Solutions",
    description:
      "From uniformed guards and mobile patrols to intervention agents and security systems—one trusted partner covers every layer of protection.",

    tTitle: "wcu.cards.bestPrices.title",
    tDesc: "wcu.cards.bestPrices.desc",

    icon: <Layers size={24} />,
  },
];

export const blogs = Object.values(BLOG_DATA)
  .map((p) => ({
    slug: p.slug,
    title: p.hero?.title,
    excerpt: p.lead?.copy || p.hero?.subtitle,
    image: p.hero?.bgImage,
    date: p.hero?.dateISO,
    readTime: p.hero?.readTimeMin,
    linkTo: `/blog/${p.slug}`,
  }))
  .sort((a, b) => new Date(b.date) - new Date(a.date));

export const footer = [
  {
    title: "Locations",
    routes: [
      { name: "Montréal", href: "/montreal" },
      { name: "Laval", href: "/laval" },
      { name: "Québec City", href: "/quebec-city" },
      { name: "Trois-Rivières", href: "/trois-rivieres" },
      { name: "Toronto", href: "/toronto" },
      { name: "Ottawa", href: "/ottawa" },
      { name: "Niagara Falls", href: "/niagara-falls" },
    ],
  },
  {
    title: "Join Us",
    tTitle: "nav.joinUs",
    routes: [
      { name: "Apply", href: "/careers", tKey: "nav.careers" },
      { name: "Montreal", href: "/montreal", tKey: "nav.montreal" },
    ],
  },
  {
    title: "Services",
    tTitle: "nav.services",
    routes: [
      { name: "Security Guards", href: "/services/security-guards", tKey: "nav.securityGuards" },
      { name: "Security Systems", href: "/services/security-systems", tKey: "nav.securitySystems" },
      { name: "Staffing Solutions", href: "/services/security-staffing", tKey: "nav.staffingSolutions" },
      { name: "Hybrid Solutions", href: "/services/hybrid-security-solutions", tKey: "nav.hybridSolutions" },
      { name: "Transportation", href: "/services/transportation-security", tKey: "nav.transportation" },
      { name: "Intervention Services", href: "/services/crisis-intervention-security", tKey: "services.interventionServices" },
    ],
  },
  {
    title: "Security Solutions",
    tTitle: "nav.securitySolutions",
    routes: [
      { name: "Event Security", href: "/services/event-security", tKey: "services.eventSecurity" },
      { name: "Residential Security", href: "/services/residential-security", tKey: "services.residentialSecurity" },
      { name: "Traffic Control", href: "/services/traffic-control", tKey: "services.trafficControl" },
      { name: "Fire Surveillance", href: "/services/fire-watch-security", tKey: "services.fireSurveillance" },
      { name: "Hospitality Services", href: "/services/hospitality-security", tKey: "services.hospitalityServices" },
      { name: "VIP Security", href: "/services/luxury-security", tKey: "services.luxurySecurity" },
      { name: "Loss Prevention", href: "/services/loss-prevention", tKey: "services.lossPrevention" },
      { name: "Construction Site Security", href: "/services/construction-site-security", tKey: "services.constructionSecurity" },
      { name: "Patrol Services", href: "/services/patrol-services", tKey: "services.patrolServices" },
      { name: "Commercial Properties", href: "/services/commercial-properties", tKey: "services.commercialProperties" },
      { name: "Educational Sector", href: "/services/education-security", tKey: "nav.educationalSector" },
      { name: "Government Services", href: "/services/government-services", tKey: "services.governmentServices" },
    ],
  },
  {
    title: "Get a Quote",
    tTitle: "nav.getAQuote",
    routes: [
      { name: "Request a Quote", href: "/contact#quote-request", tKey: "nav.requestQuote" },
      { name: "Consultation Call", href: "/contact", tKey: "nav.consultationCall" },
    ],
  },
];

export const socialHandles = [
  {
    name: "Facebook",
    icon: <FacebookIcon />,
    link: "https://www.facebook.com/p/Visionsecurite-100079664496184/",
  },
  {
    name: "Instagram",
    icon: <InstagramIcon />,
    link: "https://www.instagram.com/visionsecurity.inc/?hl=en",
  },
  {
    name: "LinkedIn",
    icon: <LinkedInIcon />,
    link: "https://www.linkedin.com/company/vision-s%C3%A9curit%C3%A9-inc/posts/?feedView=all",
  },
  {
    name: "YouTube",
    icon: <YouTubeIcon />,
    link: "https://www.youtube.com/@VisionSecurityInc",
  },
];


